module.exports = __webpack_public_path__ + "static/media/rafting.02ee7106.jpg";